import { Button, Card, Center, Group, List, Stack, Text } from "@mantine/core";
import { SubscriptionPlan } from "../Subscriptions";
import "./PlanCard.css";
import { useBreakpoints } from "../../../utils/useBreakpoints";
import { IconJetpack, IconRocket, IconSparkles } from "@tabler/icons-react";

type PlanCardProps = {
    plan: SubscriptionPlan, 
    type?: string, 
    enphatize?: boolean,
    loading: { name: string, state: boolean},
    onPress: (selected: SubscriptionPlan) => void
}

const PlanCard = (props: PlanCardProps) => {
    const { isMobile } = useBreakpoints();

    return(
        <Card mih={ !isMobile ? 384 : 0 }>
            <Card.Section withBorder style={{ padding: "8px 0px" }}>
                <Center>
                    <Text fw={700} fz={18} style={{ opacity: .5 }}>{ props.plan.label }</Text>
                </Center>

                {
                    props.plan.name === "annual"
                    &&
                    <div className="offer">consigliato</div>
                }
            </Card.Section>

            <Stack>
                <Stack gap={0}>
                    <Center>
                        <Group gap={"0px"} align="flex-start">
                            <Text fw={800} fz={50}>{ props.plan.price }</Text>
                            <Text mt={10} fw={700}>€</Text>
                        </Group>
                    </Center>
                    <Center>
                        {
                            props.enphatize
                            ?
                            <Text fw={600} fz={14} style={{ opacity: 1, color: "darkorange" }}>{ props.type ? props.type : "Per Camera" }</Text>
                            :
                            <Text fw={600} fz={14} style={{ opacity: .4 }}>{ props.type ? props.type : "Per Camera" }</Text>
                        }
                    </Center>
                </Stack>

                <List>
                    { 
                        props.plan.features.map((f, index) => 
                            <List.Item key={index} style={
                                { 
                                    opacity: (props.plan.name === "annual" && index === 0) ? 1 : .4, 
                                    color: (props.plan.name === "annual" && index === 0) ? "darkorange" : "black" 
                                }
                            }>
                                <Text fw={(props.plan.name === "annual" && index === 0) ? 700 : 400}>{ f }</Text>
                            </List.Item>
                        ) 
                    }
                    { (props.plan.name === "monthly" && !isMobile) && <List.Item style={{ opacity: 0 }}></List.Item> }
                </List>

                <Group justify="flex-end">
                    <Text style={{ opacity: .4 }}>Iva Esclusa</Text>
                </Group>
                
                <Button 
                    leftSection={
                        props.plan.name === "monthly" ? <IconRocket /> : props.plan.name === "annual" ? <IconJetpack /> : <IconSparkles />
                    }
                    variant="outline" 
                    color="orange" 
                    fullWidth 
                    mt="md" 
                    radius="md"
                    disabled={ props.loading.state === true && props.plan.name !== props.loading.name ? true : false }
                    loading={ props.plan.name === props.loading.name ? props.loading.state : false }
                    onClick={ () => props.onPress(props.plan) }
                >
                    Acquista { props.plan.label }
                </Button>
            </Stack>
        </Card>
    );
};

export default PlanCard;